import { render, staticRenderFns } from "./SpcmCounsellorList.vue?vue&type=template&id=4056d545&scoped=true"
import script from "./SpcmCounsellorList.vue?vue&type=script&lang=js"
export * from "./SpcmCounsellorList.vue?vue&type=script&lang=js"
import style0 from "./SpcmCounsellorList.vue?vue&type=style&index=0&id=4056d545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056d545",
  null
  
)

export default component.exports